import React from 'react'

import ExpirationErrorImg from 'images/expiration_error.svg'
import DealErrorTemplate from 'layouts/DealErrorTemplate'

import { track } from 'utils/trackingUtils'

const EXPIRED_HEADER = 'Oops! This invitation has expired'
const EXPIRED_DESCRIPTION = 'Your invitation to create a Drift account has expired. But don’t worry! You can reach out to your sales rep for next steps.'

const DealExpiredLayout = () => (
  <DealErrorTemplate
    splashImage={ExpirationErrorImg}
    header={EXPIRED_HEADER}
    description={EXPIRED_DESCRIPTION}
    onMounted={() => track('Deal Flow - Deal Expired Page Hit')}/>
)

export default DealExpiredLayout


// WEBPACK FOOTER //
// ./src/layouts/DealExpired/index.js